import React, {ReactNode} from 'react';
import {i18n_t} from 'app/i18n';
import {betMoney} from 'app/utils';

interface ExpressBetAcceptedDataType {
    artifacts_count?: number
    bet_sum: number
}

const expressBetAccepted = (data: ExpressBetAcceptedDataType): ReactNode => <div>
    {!data.artifacts_count || data.artifacts_count < 1
        ? i18n_t('express_bet_accepted', {bet_sum: betMoney(data, data.bet_sum, false)})
        : i18n_t('artifact_express_bet_accepted', {count: data.artifacts_count})}{'\u00A0'}
</div>;

export default expressBetAccepted;
